import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Payroll } from '@models/profileConfiguration/model';

export type PayrollState = EntityState<Payroll, string>

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'Payroll' })
export class PayrollStore extends EntityStore<PayrollState> {
  constructor() {
    super();
  }
}
